export const SET_SKIN ="SET_SKIN";

export const REGISTER = "REGISTER";
export const REGISTER_FAILED = "REGISTER_FAILED";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_REQUEST = "REGISTER_REQUEST";

export const CHANGE_FONT_SIZE ="CHANGE_FONT_SIZE";
export const CHANGE_FONT_FAMILY ="CHANGE_FONT_FAMILY";  

export const SIGN_IN ="SIGN_IN";
export const SIGN_IN_FAILED ="SIGN_IN_FAILED";
export const SIGN_IN_SUCCESS ="SIGN_IN_SUCCESS";
export const SIGN_IN_REQUEST ="SIGN_REQUEST";

export const UPDATE_CONTACT = "UPDATE_CONTACT";
export const UPDATE_CONTACT_ERROR="UPDATE_CONTACT_ERROR";
export const UPDATE_SKIN ="UPDATE_SKIN";
export const UPDATE_SKIN_ERROR = "UPDATE_SKIN_ERROR";
export const ADD_CONTACT ="ADD_CONTACT";
export const ADD_CONTACT_ERROR="ADD_CONTACT_ERROR";

export const ADD_EDUCATION ="ADD_EDUCATION";
export const UPDATE_EDUCATION = "UPDATE_EDUCATION";

export const SIGN_OUT ="SIGN_OUT";
export const SIGN_OUT_SUCCESS = 'SIGN_OUT_SUCCESS';
export const SIGN_OUT_FAILED = 'SIGN_OUT_FAILED';
export const SIGN_OUT_REQUEST ="SIGN_OUT_REQUEST";

export const REMOVE_ERROR ='REMOVE_ERROR';